export const yacanConfig = {
  connection: {
    title: "Conexão YACAN",
    subtitle:
      "Conecte sua conta YACAN para gerenciar o acesso dos seus hóspedes com suas fechaduras.",
    connected: "Conta conectada",
    notConnected: "Não conectada",
    info:
      "Ao clicar em <b>Conectar com YACAN</b>, abrirá uma janela para fazer login e autorizar o acesso. A conexão é salva para toda a sua conta e usada em todas as suas propriedades.",
    connect: "Conectar com YACAN",
    waiting: "Aguardando autorização...",
    connectedTitle: "Conta YACAN conectada",
    authActive: "Autorização ativa",
    reauthorize: "Reautorizar",
    reauthorizeTitle: "Autorizar novamente",
    disconnect: "Desconectar",
  },
  locks: {
    title: "Fechaduras desta propriedade",
    subtitle: "Selecione as fechaduras YACAN que se aplicam a <b>esta propriedade</b>.",
    selectedCount: "{count} selecionada(s)",
    noneFound: "Nenhuma fechadura foi encontrada na sua conta YACAN.",
    refresh: "Atualizar",
    placeholder: "Selecione as fechaduras…",
    summary: "{count} fechadura(s) selecionada(s)",
    empty: "Nenhuma fechadura selecionada",
    lockFallback: "Fechadura {id}",
    save: "Salvar fechaduras desta propriedade",
    saving: "Salvando...",
  },
  assign: {
    title: "Atribuição (PMS)",
    subtitle: "Atribua cada fechadura a <b>Porta principal</b>, <b>Unidade</b> ou <b>Portão</b>.",
    assignedCount: "{count} atribuída(s)",
    info:
      "Com o YACAN, <b>o acesso dos hóspedes é gerenciado pelo YACAN</b> com base na reserva: nenhum PIN é gerado aqui. Quando uma reserva é confirmada, ela é sincronizada automaticamente com o YACAN.",
    lockFallback: "Fechadura {id}",
    assignmentLabel: "Atribuição",
    typeNone: "Não atribuída",
    typeCommon: "Porta principal (compartilhada)",
    typeUnit: "Porta do apartamento",
    typeGate: "Portão / Garagem",
    unitLabel: "Unidade / Acomodação",
    unitPlaceholder: "Selecione uma unidade",
    unitFallback: "Unidade {id}",
    save: "Salvar atribuição",
    saving: "Salvando...",
  },
  msg: {
    connectStartError: "Não foi possível iniciar a conexão com o YACAN",
    popupBlocked: "Permita janelas pop-up para conectar com o YACAN.",
    connectError: "Erro ao conectar com o YACAN",
    connectSuccess: "Conta YACAN conectada com sucesso",
    connectFailed: "Não foi possível conectar com o YACAN",
    disconnectConfirm:
      "Desconectar sua conta YACAN? As reservas não serão mais sincronizadas com o YACAN.",
    disconnectSuccess: "Conta YACAN desconectada",
    disconnectError: "Não foi possível desconectar",
    locksLoadError: "Não foi possível carregar as fechaduras",
    locksLoadError2: "Erro ao carregar as fechaduras YACAN",
    selectAtLeastOne: "Selecione pelo menos uma fechadura.",
    lockDefaultName: "Fechadura YACAN",
    locksSaved: "Fechaduras salvas para esta propriedade",
    locksSaveError: "Não foi possível salvar as fechaduras",
    saveError: "Erro ao salvar",
    selectUnitForApartment: "Selecione a unidade para fechaduras do tipo 'Porta do apartamento'.",
    assignSaved: "Atribuição salva com sucesso",
    assignSaveError: "Não foi possível salvar a atribuição",
    assignSaveError2: "Erro ao salvar a atribuição",
  },
};
